module.exports = __webpack_public_path__ + "img/l_c2.b25fd213.png";